module.exports = global["$"] = require("-!/app/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 518
// module chunks = 6